import React from "react";
import Calculator from "./components/Calculator";
import "./styles.css";

function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;